import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import React from "react";
import { useGoToMyResourceDetailsHistory } from "../paths";

type Props = {
  insuranceImportId: string;
  insuranceCoverageId: string;
  isCompactView?: boolean;
};

export const MyResourceInsuranceImportHistory: React.FC<Props> = ({
  insuranceImportId,
  isCompactView,
  insuranceCoverageId
}) => {
  const goToMyResourceDetailsHistory = useGoToMyResourceDetailsHistory();
  const resources = [
    {
      resourceType: "InsuranceImport",
      resourceId: insuranceImportId
    },
    {
      resourceType: "InsuranceCoverage",
      resourceId: insuranceCoverageId
    }
  ];

  return (
    <ResourceHistory
      resources={resources}
      onViewAll={
        isCompactView
          ? () => goToMyResourceDetailsHistory(insuranceCoverageId)
          : undefined
      }
    />
  );
};
